﻿import React from 'react';
import throttle from '../../../../../Utils/throttle';

const PossessionsTableHeaderMobile = ({ parent, content, selected, heading }) => {

    const [sticky, setSticky] = React.useState("");

    const ref = React.useRef();

    let stickyClass = "";

    React.useEffect(() => {
        window.addEventListener("scroll", throttle(handleScroll), 400);

        return () => {
            window.removeEventListener("scroll", throttle(handleScroll));
        };
    }, []);


    const handleScroll = () => {

        if (parent && parent.current) {

            const windowTop = window.scrollY;
            const elemTop = parent.current.getBoundingClientRect().top;
            const elemBottom = parent.current.getBoundingClientRect().bottom;
            const stickyHeight = ref.current.scrollHeight;

            let stickPosition = elemTop + windowTop;
            let unstickPosition = elemBottom + windowTop - stickyHeight;

            if (windowTop > stickPosition && windowTop < unstickPosition) {
                stickyClass = "sticky";
                setSticky(stickyClass);
            }

            if (windowTop >= unstickPosition || windowTop <= stickPosition) {
                stickyClass = "";
                setSticky(stickyClass);
            }
        }
    }

    const classes = `possessions__table__mobile__header__levels ${sticky}`;

    return (
        <div className="possessions__table__mobile__header">
            <h4 className="possessions__table__mobile__header__heading">{heading}</h4>

            <div className={classes} ref={ref}>
                {content.levels.map(level =>
                    <div key={level.label}
                        className={`possessions__table__mobile__header__level ${selected === level.label ? "selected" : ""}`}>
                        {selected === level.label && <span>Vald</span>}
                        {level.label}
                    </div>
                )}
            </div>
        </div>
    )
};

export default PossessionsTableHeaderMobile;

